import React, { useEffect, useState } from "react";
import axios from "axios";

function formatCurrency(amount) {
  return `₹${parseFloat(amount || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
  })}`;
}

function DashboardCards() {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [financials, setFinancials] = useState(null);

  // 🔁 Fetch project list for dropdown
  useEffect(() => {
    axios
      .get(`${baseUrl}/projects`)
      .then((res) => {
        setProjects(res.data || []);
        if (res.data.length > 0) {
          setSelectedProject(res.data[0]); // Set default project
        }
      })
      .catch((err) => {
        console.error("❌ Failed to load projects", err);
      });
  }, []);

  // 🔁 Update financials when selected project changes
  useEffect(() => {
    if (selectedProject) {
      const {
        budget_allocated,
        actual_cost,
        consultant_fees = 0,
        material_cost = 0,
        labor_cost = 0,
        revenue_from_client = 0,
      } = selectedProject;

      const total_cost =
        parseFloat(actual_cost || 0) +
        parseFloat(consultant_fees || 0) +
        parseFloat(material_cost || 0) +
        parseFloat(labor_cost || 0);

      const profit =
        parseFloat(revenue_from_client || 0) - parseFloat(total_cost);
      const profit_margin = revenue_from_client
        ? (profit / revenue_from_client) * 100
        : 0;

      setFinancials({
        budget_allocated,
        actual_cost,
        consultant_fees,
        material_cost,
        labor_cost,
        revenue_from_client,
        total_cost,
        profit,
        profit_margin,
      });
    }
  }, [selectedProject]);

  if (!selectedProject || !financials) return <div>Loading...</div>;

  const cardData = [
    {
      title: "Budget Allocated",
      value: financials.budget_allocated,
      color: "bg-blue-100 text-blue-700",
    },
    {
      title: "Actual Cost",
      value: financials.actual_cost,
      color: "bg-red-100 text-red-700",
    },
    {
      title: "Consultant Fees",
      value: financials.consultant_fees,
      color: "bg-purple-100 text-purple-700",
    },
    {
      title: "Material Cost",
      value: financials.material_cost,
      color: "bg-yellow-100 text-yellow-700",
    },
    {
      title: "Labor Cost",
      value: financials.labor_cost,
      color: "bg-orange-100 text-orange-700",
    },
    {
      title: "Revenue From Client",
      value: financials.revenue_from_client,
      color: "bg-green-100 text-green-700",
    },
    // {
    //   title: "Total Cost (Calculated)",
    //   value: financials.total_cost,
    //   color: "bg-gray-300 text-gray-800",
    // },
    // {
    //   title: "Total Profit",
    //   value: financials.profit,
    //   color: "bg-lime-100 text-lime-700",
    // },
    // {
    //   title: "Profit Margin (%)",
    //   value: `${financials.profit_margin.toFixed(2)} %`,
    //   color: "bg-cyan-100 text-cyan-700",
    // },
  ];

  return (
    <div className="mt-6 p-4">
      {/* ✅ Project Dropdown */}
      <div className="mb-4">
        <label className="block text-sm font-semibold mb-1 text-gray-700">
          Select Project:
        </label>
        <select
          className="p-2 border rounded w-full sm:w-1/2"
          value={selectedProject.project_name}
          onChange={(e) => {
            const selected = projects.find(
              (proj) => proj.project_name === e.target.value
            );
            setSelectedProject(selected);
          }}
        >
          {projects.map((proj, i) => (
            <option key={i} value={proj.project_name}>
              {proj.project_name}
            </option>
          ))}
        </select>
      </div>

      {/* ✅ Dynamic Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-4">
        {cardData.map(({ title, value, color }, index) => (
          <div key={index} className={`p-4 rounded shadow ${color}`}>
            <h3 className="text-sm font-semibold mb-1">{title}</h3>
            <p className="text-lg font-bold">
              {typeof value === "number" ? formatCurrency(value) : value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default DashboardCards;
